import React from 'react'
import Link from './link'

export type TeaserProps = {
  url?: string
  header: React.ReactNode
  logo: React.ReactNode
  children: React.ReactNode
  type: 'offer' | 'firm' | 'tool' | 'group'
}
const Teaser: React.FC<TeaserProps> = ({
  url = undefined,
  header,
  logo,
  children,
  type,
}) => {
  let containerClassName = ''
  let headerContainerClassName = ''
  let logoContainerClassName = ''
  let contentContainerClassName = ''

  // eslint-disable-next-line default-case
  switch (type) {
    case 'offer':
      containerClassName =
        'bg-white relative flex flex-col lg:flex-row lg:h-36 rounded-xl hover:-translate-y-1 shadow-md hover:shadow-lg transition-all duration-300 ease-in-out overflow-hidden'
      headerContainerClassName = 'h-32 lg:h-36 lg:w-1/4'
      logoContainerClassName =
        'absolute top-12 lg:top-[calc(50%_-_3rem)] left-[calc(50%_-_3rem)] lg:left-[calc(25%_-_5.5rem)] shadow w-24 h-24 bg-white rounded-xl p-2'
      contentContainerClassName =
        'relative p-6 lg:ml-8 lg:mr-4 grow flex flex-col justify-center gap-4 lg:gap-2 lg:py-4 lg:w-3/4 lg:px-0 text-night'
      break
    case 'firm':
    case 'group':
      containerClassName =
        'bg-white relative flex flex-col w-full lg:w-[16.5rem] lg:min-h-full rounded-xl hover:-translate-y-1 shadow-md hover:shadow-lg transition-all duration-300 ease-in-out overflow-hidden'
      headerContainerClassName = 'h-32 lg:h-36'
      logoContainerClassName =
        'absolute top-24 left-8 shadow w-24 h-24 bg-white rounded-xl p-2'
      contentContainerClassName =
        'relative ml-5 mb-4 mt-14 grow flex flex-col justify-between gap-2'
      break
    case 'tool':
      containerClassName =
        'bg-white relative flex flex-col lg:min-h-full lg:w-[16.5rem] rounded-xl hover:-translate-y-1 shadow-md hover:shadow-lg transition-all duration-300 ease-in-out overflow-hidden'
      headerContainerClassName = 'h-32'
      logoContainerClassName =
        'absolute top-16 left-8 shadow w-24 h-24 bg-white rounded-xl p-2'
      contentContainerClassName =
        'relative ml-5 mb-4 mt-9 grow flex flex-col justify-between gap-2'
      break
  }

  if (url) {
    return (
      <Link to={url} className={containerClassName}>
        <div className={headerContainerClassName}>{header}</div>
        <div className={logoContainerClassName}>{logo}</div>
        <div className={contentContainerClassName}>{children}</div>
      </Link>
    )
  }
  return (
    <div className={containerClassName}>
      <div className={headerContainerClassName}>{header}</div>
      <div className={logoContainerClassName}>{logo}</div>
      <div className={contentContainerClassName}>{children}</div>
    </div>
  )
}

export default Teaser
